// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_countUp.js'; import './autoload/_forms.js'; import './autoload/_frontend.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import styles from blocks

import '../gutenberg/blocks/accordion-item/styles.scss'; import '../gutenberg/blocks/accordion/styles.scss'; import '../gutenberg/blocks/animated-number-counter/styles.scss'; import '../gutenberg/blocks/animated-number-counters/styles.scss'; import '../gutenberg/blocks/benefit-collection-item/styles.scss'; import '../gutenberg/blocks/benefit-collection-items/styles.scss'; import '../gutenberg/blocks/button/styles.scss'; import '../gutenberg/blocks/buttons/styles.scss'; import '../gutenberg/blocks/chip/styles.scss'; import '../gutenberg/blocks/content-item/styles.scss'; import '../gutenberg/blocks/highlight-box/styles.scss'; import '../gutenberg/blocks/icon-box-collection/styles.scss'; import '../gutenberg/blocks/icon-box/styles.scss'; import '../gutenberg/blocks/image-comparison/styles.scss'; import '../gutenberg/blocks/image-grid/styles.scss'; import '../gutenberg/blocks/image-text-block/styles.scss'; import '../gutenberg/blocks/person-block/styles.scss'; import '../gutenberg/blocks/project-grid-text-item/styles.scss'; import '../gutenberg/blocks/table-agenda-items/styles.scss' // eslint-disable-line

//frontend blocks
import '../gutenberg/blocks/accordion/functions'

import './menu'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

import { onDocumentReady } from './util/events'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
onDocumentReady(() => routes.loadEvents())
